import React from 'react';
import { AppleIcon, SmartphoneIcon } from 'lucide-react';
import { appLinks } from '../data/appTour';
interface AppStoreButtonsProps {
  /** 'light' sits on ivory/white surfaces, 'dark' sits on charcoal surfaces. */
  tone?: 'light' | 'dark';
  className?: string;
}
export function AppStoreButtons({
  tone = 'light',
  className = ''
}: AppStoreButtonsProps) {
  const base = 'inline-flex items-center gap-3 rounded-full px-7 py-4 font-sans text-base font-semibold transition-colors duration-200 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2';
  const styles = tone === 'dark' ? {
    primary: 'bg-purple-500 text-white hover:bg-purple-400 focus-visible:ring-purple-300 focus-visible:ring-offset-charcoal',
    secondary: 'border border-ivory/40 text-ivory hover:bg-ivory hover:text-charcoal focus-visible:ring-purple-300 focus-visible:ring-offset-charcoal'
  } : {
    primary: 'bg-purple-700 text-white hover:bg-purple-800 focus-visible:ring-purple-600 focus-visible:ring-offset-ivory',
    secondary: 'border border-charcoal/25 text-charcoal hover:border-purple-700 hover:text-purple-800 focus-visible:ring-purple-600 focus-visible:ring-offset-ivory'
  };
  return <div className={`flex flex-col sm:flex-row gap-4 ${className}`} data-id="element-5" data-mp="39w0zbas2yn06">
      <a href={appLinks.apple} target="_blank" rel="noopener noreferrer" className={`${base} ${styles.primary}`} data-id="element-6" data-mp="afku7u5foa6h">
        <AppleIcon aria-hidden="true" className="w-5 h-5" data-id="element-7" data-mp="6f0xgrorv8kv" />
        Download for iPhone
      </a>
      <a href={appLinks.android} target="_blank" rel="noopener noreferrer" className={`${base} ${styles.secondary}`} data-id="element-8" data-mp="1dbkv7lwimuo">
        <SmartphoneIcon aria-hidden="true" className="w-5 h-5" data-id="element-9" data-mp="2m5wzlei0j7eg" />
        Download for Android
      </a>
    </div>;
}